<template>
  <div class="skill_type">
    <div class="name">{{ model.data.name }}</div>
    <div class="skills">
      <skill v-for="(item, i) in model.findSkillList()"
             :key="i"
             :model="item"></skill>
    </div>
  </div>
</template>

<script>

import Skill from '@/components/print-resume/skill';

export default {
    name       : "SkillType",
    components : { Skill },
    props      : {
        model : {
            type : Object
        }
    }
};

</script>

<style scoped>

.skill_type {
    width:180px;
    padding-bottom:70px;
}

.skill_type .name {
    font-size:13px;
    margin-bottom:10px;
    text-align:center;
}

</style>
